// Keep app display labels and internal links in the storefront's active language.
(() => {
  const config = document.getElementById('fs-widget-localization');
  if (!config || document.documentElement.lang !== 'ar') return;
  const labels = JSON.parse(config.textContent);
  const rootSelector = '.lb-bundle-cont, .jdgm-widget';
  const rules = [
    ['.lb-bundle-cta-total-title', 'Total', labels.total],
    ['.lb-bundle-cta-total-subTitle', 'Selected items will be added to cart.', labels.selected],
    ['.lb-button-bundle [role="button"]', 'Add bundle to cart', labels.addBundle],
    ['.lb-visually-hidden', 'Regular price', labels.regularPrice],
    ['.lb-visually-hidden', 'Sale price', labels.salePrice],
    ['.jm-sort-filter label, .jdgm-sort-dropdown-label', 'Sort reviews by', labels.sort],
    ['.jm-sort-filter label, .jdgm-sort-dropdown-label', 'Sort by', labels.sort],
  ];
  const pending = new Set();
  let frame = 0;

  function localize(root) {
    for (const [selector, source, translation] of rules) {
      for (const element of root.querySelectorAll(selector)) {
        for (const node of element.childNodes) {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === source) {
            node.textContent = node.textContent.replace(source, translation);
          }
        }
      }
    }
    for (const link of root.querySelectorAll('a[href]')) {
      const url = new URL(link.getAttribute('href'), location.href);
      if (url.origin !== location.origin || !/^\/(products|collections|pages|blogs)\//.test(url.pathname)) continue;
      url.pathname = labels.root.replace(/\/$/, '') + url.pathname;
      link.setAttribute('href', url.pathname + url.search + url.hash);
    }
  }

  function collect(node) {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    if (!element) return;
    const root = element.closest(rootSelector);
    if (root) pending.add(root);
    for (const widget of element.querySelectorAll(rootSelector)) pending.add(widget);
  }

  function flush() {
    frame = 0;
    for (const root of pending) if (root.isConnected) localize(root);
    pending.clear();
  }

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      const root = record.target.parentElement?.closest(rootSelector);
      if (root) pending.add(root);
      for (const node of record.addedNodes) collect(node);
    }
    if (pending.size && !frame) frame = requestAnimationFrame(flush);
  });
  function start() {
    for (const root of document.querySelectorAll(rootSelector)) localize(root);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  start();
  window.addEventListener('pagehide', () => {
    observer.disconnect();
    cancelAnimationFrame(frame);
    frame = 0;
    pending.clear();
  });
  window.addEventListener('pageshow', (event) => { if (event.persisted) start(); });
})();

